<script>
  import axios from "axios"
  import Navbar from "../../../../Shared/Navbar/index.svelte"
  import Footer from "../../../../Shared/footer.svelte"
  import SinglePublish, { updateSinglePublish } from "../Stores/singlePublishStore"
  import Authentication, { updateAuth } from "../../DocSigning/Stores/authStore"
  import ApplicationState from "../../../../Stores/applicationStates"
  import notify from "../../../../Script/notify"
  import LoadingScreen from "../Components/loadingScreen.svelte"
  import { onMount } from "svelte"
  import { getDocumentIdDetails } from "../script"
  import { querystring, push } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../../Script/queryString"

  /**
   * @type {Object} - object get from window location
   */
  let query = queryStringToJSON($querystring)

  // let singlePublishPage

  /**
   * fetch new document id details
   */
  onMount(async () => {
    // typeWriter(singlePublishPage, "Single Document Publishing", 0)
    // if (query.docketId) push(`/publish/single/upload_document?documentId=${query.documentId}&docketId=${query.docketId}`)
    let stats = localStorage.getItem("P2BSinglePublish")
    if (!stats) {
      $SinglePublish = {}
    }
    //set new documnet id details to the local storage
    try {
      // if ($SinglePublish.documentId != query.documentId && query.documentId) {
      if (query.documentId) {
        apiCallBtnDisable = true
        $Authentication.token = ""
        updateAuth($Authentication)

        await getDocumentIdDetails()
        resume()
      }
    } catch (error) {
      // console.error(error)
      const info = "PAGE: Single Publish (Intro Page)\nEVENT: onMount"
      initErrorNotify = notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  })

  /**
   * Controls the state of the API call button.
   * @type {boolean}
   */
  let apiCallBtnDisable = false

  /**
   * @type {initErrorNotify} - initiat error notification
   */
  let initErrorNotify = {
    close() {},
  }

  /**
   * @type {String} - massage for loading screen
   */
  let msg = "Fetching document data"

  /**
   * Starts a new process by creating new Document object.
   * @function startNew
   */
  const startNew = async () => {
    // Clear local storage and reset the $SinglePublish object
    localStorage.removeItem("P2BSinglePublish")
    $SinglePublish = {}

    // Close any existing error notification
    initErrorNotify.close()
    try {
      // Enable the loading screen
      apiCallBtnDisable = true
      // Fetching list of document templates
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
      const { data } = await axios.post(
        // `/api/swagger/v2/docs/initiate?qrcode=true`,
        `/api/swagger/v2/documents?qrcode=true`,
        { filename: "publish" },
        {
          headers: {
            "x-access-token": $ApplicationState.token,
          },
        }
      )
      // Check if the response has an error and is not successful
      if (data.error && !data.success) {
        throw data.errorCode // Throw the error code
      }
      //document id, view page proposed url and qrcode data saved to store
      $SinglePublish.QRCode = data.proposedURL
      $SinglePublish.uri = data.proposedURL
      $SinglePublish.documentId = data.documentID
      // setTimeout(() => {
      //   localStorage.removeItem("P2BSinglePublish")
      //   $SinglePublish = {}
      //   updateSinglePublish($SinglePublish)
      // }, 43200000)//half day
      $Authentication.token = ""
      // update auth stores after clearing token to start the fresh process for publishing the document.
      updateAuth($Authentication)
      // update the single publish stores
      updateSinglePublish($SinglePublish)
      // push(`/publish/single/choose_template?documentId=${$SinglePublish.documentId}`)
      push(`/publish/single/upload_document?documentId=${$SinglePublish.documentId}`)
    } catch (error) {
      // Show an error notification
      // console.error(error)
      const info = "PAGE: Single Publish (Intro Page)\nEVENT: During Single Publish initiate"
      initErrorNotify = notify.danger(error, info)
    } finally {
      // Disable the loading screen
      apiCallBtnDisable = false
    }
  }

  /**
   * continue with old process process
   * @function resume
   */
  const resume = () => {
    // Check the state of the document publishing process and navigate accordingly
    if (!$SinglePublish.fileHash) {
      // If file hash is missing, navigate to upload_document step
      push(`/publish/single/upload_document?documentId=${$SinglePublish.documentId}`)
    } else if (!$SinglePublish.dataHash) {
      // If data hash is missing, navigate to metadata step
      // push(`/publish/single/metadata?documentId=${$SinglePublish.documentId}`)
      push(`/publish/single/choose_template?documentId=${$SinglePublish.documentId}`)
    } else if (!$SinglePublish.datePublished) {
      // If proposed URL is missing, navigate to preview step
      push(`/publish/single/preview?documentId=${$SinglePublish.documentId}`)
    } else if ($SinglePublish.docketId) {
      // If docketID is found, navigate to docket page
      push(`/signing/single/docket?id=${$SinglePublish.docketId}`)
    } else {
      // If all required data is available, navigate to qrcode step
      push(`/publish/single/qrcode?documentId=${$SinglePublish.documentId}`)
    }
  }
</script>

<svelte:head>
  <title>Single Document Publish</title>
</svelte:head>

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />

  <div class="px-6">
    <div class="mx-auto h-auto w-full max-w-[920px] pb-40 pt-3">
      <div class="mt-6 flex min-h-[470px] w-full flex-col justify-between rounded-md bg-white p-6 dark:bg-mdGray mobile:p-12">
        <div class=" select-none space-y-3 opacity-100">
          <h1 class="leading text-3xl font-bold dark:text-white mobile:text-5xl">
            Single <br />
            Document
            <br />
            Publishing
          </h1>

          <!-- svelte-ignore a11y-missing-content -->
          <!-- <h1 bind:this={text1} class="leading relative w-[max-content] text-3xl font-bold text-white before:absolute before:inset-0 before:animate-typewriter before:bg-white dark:text-white mobile:text-5xl" /> -->

          <div class="w-full sm:w-3/5">
            <p class="break-words text-justify text-sm text-gray-500 dark:text-gray-300 mobile:text-base">
              Effortlessly publish and share secure, blockchain-verified documents with DocChain—simply upload, customize, and receive a blockchain-secured link for your confidence.
              <!-- Hello, This is the <strong>single document publishing</strong>
              window, where you can
              publish a new single document. -->
            </p>
          </div>
        </div>

        <div class="flex items-center justify-end">
          <div class="flex gap-3">
            {#if $SinglePublish.documentId}
              <button type="button" on:click={resume} class:hidden={!$SinglePublish.documentId} class="flex h-9 w-1/3 min-w-fit cursor-pointer items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-300 lg:px-4">
                {#if $SinglePublish.datePublished}
                  <i class="fa-solid fa-eye" />
                  <span class="flex select-none sm:hidden">&nbsp;&nbsp;View&nbsp;URL&nbsp;</span>
                  <span class="hidden select-none sm:flex">&nbsp;&nbsp;View&nbsp;Published&nbsp;URL&nbsp;</span>
                {:else}
                  <i class="fa-solid fa-circle-play" />
                  <span class="select-none">&nbsp;&nbsp;Resume&nbsp;</span>
                {/if}
              </button>
            {/if}
            <button disabled={apiCallBtnDisable} type="button" on:click={startNew} class="flex h-9 w-32 min-w-[36px] cursor-pointer items-center justify-center rounded-md border border-[#a0a1a580] bg-green-500 px-2 text-sm font-medium text-white hover:bg-green-600 hover:text-white focus:outline-none active:bg-green-500 disabled:cursor-not-allowed disabled:bg-green-300 lg:px-4">
              <i class="fa-solid {$SinglePublish.documentId ? 'fa-rotate-left' : 'fa-circle-play'}" />
              <span class="select-none">&nbsp;&nbsp;{$SinglePublish.documentId ? "Start New" : "Start"}&nbsp;</span>
            </button>
          </div>
        </div>
        {#if apiCallBtnDisable}
          <LoadingScreen msg={"Document ID creating"} />
        {/if}
      </div>
    </div>
  </div>
  {#if apiCallBtnDisable}
    <LoadingScreen {msg} />
  {/if}
  <Footer />
</div>

<style>
  .leading {
    line-height: 4rem;
  }
</style>
